"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDate = exports.serializeDate = void 0;
const serializeDate = (item) => {
    return typeof item.data.value === "string" ? item.data.value : "";
};
exports.serializeDate = serializeDate;
const validateDate = (item) => {
    if (!item.required || item.data.value) {
        return { valid: true };
    }
    return {
        valid: false,
        error: {
            message: `Date${item.type === "DateTime" ? " and Time" : ""} must be chosen.`,
        },
    };
};
exports.validateDate = validateDate;
//# sourceMappingURL=date.js.map